import apiClient from './client';

/**
 * GET /customers?page=&page_size=&search=
 */
export async function listCustomers({ page = 1, pageSize = 50, search } = {}) {
  const params = { page, page_size: pageSize };
  if (search) params.search = search;
  const response = await apiClient.get('/customers', { params });
  return response.data;
}

export async function getCustomer(customerId) {
  const response = await apiClient.get(`/customers/${customerId}`);
  return response.data;
}

/**
 * POST /customers
 *
 * Body: CustomerCreate shape — only `name` is required; everything
 * else (contact_name, email, phone, address pieces, VAT/TIN, credit
 * limit, notes) is optional. Backend returns the created CustomerOut.
 */
export async function createCustomer(payload) {
  const response = await apiClient.post('/customers', payload);
  return response.data;
}

/**
 * GET /customers/{id}/financial-summary
 *
 * Returns { invoiced, received, outstanding, draft } — totals across
 * all the customer's sales. Used by CustomerDetail to surface a quick
 * snapshot of how the customer's account stands without forcing the
 * rep to drill into the orders / ledger views (which live on desktop).
 */
export async function getCustomerFinancialSummary(customerId) {
  const response = await apiClient.get(
    `/customers/${customerId}/financial-summary`,
  );
  return response.data;
}
